import * as yup from 'yup';

import {
  isBirthDateValid,
  isCellPhone,
  isCpf,
  isEmail,
  isFullName,
} from '~/utils/yup';

export const firstStepSchema = yup
  .object()
  .shape({
    fullName: isFullName(),
    email: isEmail(),
    cellphone: isCellPhone(),
    acceptAccessionTerms: yup.bool().isTrue().required(),
    acceptGeneralConditions: yup.bool().isTrue().required(),
  })
  .required();

export const secondStepSchema = yup
  .object()
  .shape({
    cpf: isCpf(),
    birthDate: isBirthDateValid({}),
    gender: yup.string().required('Este campo é obrigatório'),
    maritalStatus: yup.string().required('Este campo é obrigatório'),
  })
  .required();

export const thirdStepSchema = yup
  .object()
  .shape({
    zipcode: yup.string().required('Este campo é obrigatório'),
    street: yup.string().required('Este campo é obrigatório'),
    noNumber: yup.boolean(),
    noComplement: yup.boolean(),
    number: yup.string().when('noNumber', {
      is: false,
      then: yup
        .string()
        .required(
          `Informe o número da residência ou toque no checkbox "Sem número".`
        ),
    }),
    complement: yup.string().when('noComplement', {
      is: false,
      then: yup
        .string()
        .required(
          `Informe o complemento ou toque no checkbox "Sem complemento".`
        ),
    }),
    neighborhood: yup.string().required('Este campo é obrigatório'),
    city: yup.string().required('Este campo é obrigatório'),
    state: yup.string().required('.'),
  })
  .required();
